import { Injectable, NgZone } from "@angular/core";
import { localize } from "@gtmhub/localization";
import { UiModalRef } from "@webapp/ui/modal/abstracts/modal-ref";
import { UiModalService } from "@webapp/ui/modal/services/modal.service";
import { AddTeamAvatarFormComponent } from "../components/add-team-avatar-form/add-team-avatar-form.component";
import { Team } from "../models/teams.models";

@Injectable()
export class AddTeamAvatarModalService {
  constructor(private modalService: UiModalService, private ngZone: NgZone) {}

  public openAddTeamAvatarModal(team: Team): UiModalRef<AddTeamAvatarFormComponent> {
    let modalRef: UiModalRef<AddTeamAvatarFormComponent>;

    this.ngZone.run(() => {
      modalRef = this.modalService.create<AddTeamAvatarFormComponent>({
        uiTitle: localize("create_team_avatar"),
        uiContent: AddTeamAvatarFormComponent,
        uiWidth: 584,
        uiMaskClosable: true,
        uiData: {
          team,
        },
        uiOkText: localize("apply"),
        uiOnOk: (component) => {
          component.onApply();
        },
        uiCancelText: localize("cancel"),
        uiOnCancel: (component) => {
          component.closeModal();
        },
      });
    });

    return modalRef;
  }
}
